const handler = async function(event) {
  event.target.style.right = "1px"
  event.target.getBoundingClientRect()
  event.target.style.right = null
}

$(document).ready(function() {
  $(`.off-canvas.position-right`).on(`transitionend`, handler)
})
